import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Empty, PageHeader, Spinner } from "@/components/rp";

export default function AdminMessaggi() {
  const [threads, setThreads] = useState(null);
  useEffect(() => {
    const load = () => api.get("/admin/threads").then((r) => setThreads(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="max-w-3xl">
      <PageHeader label="Messaggi" title="Conversazioni" />
      {!threads ? <Spinner /> : !threads.length ? (
        <Empty icon={MessageCircle} title="Nessuna conversazione" text="Apri un cliente e usa “Chat” per scrivergli." data-testid="threads-empty" />
      ) : (
        <div className="rp-card divide-y divide-[#EBEBEB] overflow-hidden" data-testid="threads-list">
          {threads.map((t) => (
            <Link key={t.client_id} to={`/admin/messaggi/${t.client_id}`} data-testid={`thread-${t.client_id}`} className="flex items-center gap-4 p-4 sm:px-6 hover:bg-white transition-colors">
              <span className="h-11 w-11 rounded-full bg-[#E6DDCE] flex items-center justify-center font-semibold shrink-0">{t.client_name.charAt(0).toUpperCase()}</span>
              <span className="flex-1 min-w-0">
                <span className="flex justify-between gap-2"><span className={`truncate ${t.unread ? "font-semibold" : "font-medium"}`}>{t.client_name}</span><span className="text-xs text-[#757575] shrink-0">{fmtDateTime(t.last_at)}</span></span>
                <span className={`block text-sm truncate ${t.unread ? "text-black" : "text-[#757575]"}`}>{t.last_text}</span>
              </span>
              {t.unread > 0 && <span className="h-6 min-w-[24px] px-2 rounded-full bg-[#070707] text-white text-xs font-semibold flex items-center justify-center">{t.unread}</span>}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
